import store from './tournament-store';
import routes from './tournament-routes';

const components = [];
const mixins = [];
const filters = [];
const directives = [];

export default {
  components,
  mixins,
  filters,
  directives,
  routes,
  store
};



// WEBPACK FOOTER //
// ./src/entities/tournament/tournament-module.js